import React, { Fragment, useEffect } from "react";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchCountryFormList } from "../actions/country";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const CountryList = () => {
  const dispatch = useDispatch();

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "country";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchCountryFormList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id) return null;
    return (
      <ButtonColumn
        editLink={`/country-edit/` + params.data.id}
        value={params}
      />
    );
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("countryForm.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 200,
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 80,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={countryFormList}
        columnDefs={columnDefs}
        buttonLink={`/country-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"country-list"}
      />
    </Fragment>
  );
};

export default CountryList;
